import PropTypes from "prop-types";

export default function Divider({
  className = "",
  id = "",
  size = "small",
  variant = "secondary"
}) {
  const classNames = ["lds-divider"];

  classNames.push(`lds-divider-${size}`);
  classNames.push(`lds-divider-${variant}`);
  classNames.push(className);

  return (
    <hr id={id} className={classNames.join(" ")} />
  );
}

Divider.propTypes = {
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(["large", "small"]),
  variant: PropTypes.oneOf(["primary", "secondary"]),
};
